/* "Watch the film" — the shared behaviour for every film popup.
   ---------------------------------------------------------------------------
   Two jobs, both about what happens to the REST of the page while a film is
   up: stop anything else that is playing, and mark the page so film-popup.css
   can blur and darken behind it. Two films moving at once is horrible to look
   at, and on the collection pages there can be a header film AND a text-block
   film on the same page.

   The popup itself is not ours. video-popup.js opens it and PhotoSwipe owns it
   from there, so rather than reach into either, this watches the .pswp element
   the theme keeps in the DOM and lifts the treatment when it goes away.

   Triggered by [data-film-popup], NOT by [data-video-play] on its own: product
   galleries and the stock video section use the same popup, and they should
   keep the theme's own look rather than inherit this one.

   Closing is detected by computed display rather than a class name, because
   the class names belong to PhotoSwipe and a rename upstream would leave the
   page blurred with no way back. Display is what actually hides it. */
(function () {
  'use strict';

  var OPEN_CLASS = 'film-popup-open';
  var root = document.documentElement;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-film-popup]');
    if (!trigger) return;

    var paused = pauseEverything(trigger);

    root.classList.add(OPEN_CLASS);
    watchForClose(paused);
  });

  /* Pause every video that is currently playing, and hand back the list so it
     can be put back exactly as it was. A video the visitor had already paused
     stays paused when the film closes. */
  function pauseEverything(trigger) {
    var paused = [];

    document.querySelectorAll('video').forEach(function (video) {
      if (video.paused) return;
      if (trigger.contains(video)) return;

      paused.push(video);

      try {
        video.pause();
      } catch (e) {
        /* A video that will not pause is still worth blurring behind. */
      }
    });

    return paused;
  }

  function watchForClose(paused) {
    var pswp = document.querySelector('.pswp');

    if (!pswp) {
      restore(paused);
      return;
    }

    var opened = false;

    var poll = setInterval(function () {
      var visible = window.getComputedStyle(pswp).display !== 'none';

      if (visible) {
        opened = true;
        return;
      }

      if (opened) {
        clearInterval(poll);
        restore(paused);
      }
    }, 250);

    /* If the popup never opened, something upstream failed. Take the treatment
       off rather than leave the page blurred behind nothing. */
    setTimeout(function () {
      if (!opened) {
        clearInterval(poll);
        restore(paused);
      }
    }, 5000);
  }

  function restore(paused) {
    root.classList.remove(OPEN_CLASS);

    paused.forEach(function (video) {
      var played = video.play();
      if (played && typeof played.catch === 'function') {
        played.catch(function () {
          /* Autoplay can be refused on the way back. The poster is still there. */
        });
      }
    });
  }
})();
